module.exports = __webpack_public_path__ + "img/budsofbruin.042b5449.png";